import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { painPoints } from '../data/salesData';
export function ProblemSection() {
  return <section className="border-b border-[var(--olive)]/30 py-16 sm:py-20" data-id="element-186" data-mp="30gxvo1selnov">
      <div className="mx-auto max-w-4xl px-4" data-id="element-187" data-mp="30j0unbbjar5q">
        <SectionHeading data-id="element-188" data-mp="2vpg587o0b5i5">
          ¿Cuántos domingos más vas a perder así?
        </SectionHeading>

        <div className="mx-auto mt-8 max-w-2xl space-y-4 text-white/75" data-id="element-189" data-mp="39guomfltt8pq">
          <p data-id="element-190" data-mp="35gkgawaka67p">
            Sos profe de Pilates. Amás lo que hacés. Pero nadie te dijo que ibas
            a pasar los domingos buscando ejercicios que no tienen progresión,
            armando clases a último momento y llegando al lunes con material que
            “más o menos sirve”.
          </p>
          <p className="text-lg font-semibold text-[var(--gold-light)]" data-id="element-191" data-mp="1p1ixiuogkps6">
            No es falta de vocación. Es falta de un sistema.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 sm:grid-cols-2" data-id="element-192" data-mp="1k52c488n8pis">
          {painPoints.map(point => <li key={point} className="flex items-start gap-3 rounded-xl border border-red-500/20 bg-red-500/[0.04] p-4" data-id="element-193" data-mp="oc7vzcf1a5gp">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-500/15" data-id="element-194" data-mp="sc8nnyr58d5p">
                <XIcon className="h-4 w-4 text-red-400" aria-hidden="true" data-id="element-195" data-mp="x6mle7ta2wdj" />
              </span>
              <span className="text-white/80" data-id="element-196" data-mp="125pd6qk8z63k">{point}</span>
            </li>)}
        </ul>

        <p className="mt-10 text-center font-serif-display text-2xl font-semibold text-[var(--cream)] sm:text-3xl" data-id="element-197" data-mp="174skkhnp9oep">
          ¿Y si este fuera el último domingo que pasás así?
        </p>
      </div>
    </section>;
}